<div class="edit-property-container" ngStyle.lt-lg="width: 95%">
  <!-- <app-breadcrumb *ngIf="property && projectName" [projectName]="projectName" [unitNum]="property.unitNum"></app-breadcrumb> -->
  <div *ngIf="!isLoading"
    style="display: flex; justify-content: space-between; align-items: center;border-bottom: 1px solid rgba(222, 222, 222, 0.4);padding: 32px;">
    <div class="fc_DEDEDE title">EDIT PROPERTY</div>
    <div style="display: flex; align-items: center">
      <!--      <h4 *ngIf="property" style="font-weight: lighter; font-size: 14px">(Recently updated-->
      <!--        on {{property.updateTime | date}})</h4>-->
      <button mat-button class="delete-property" (click)="openDeletePropertyDialog()">DELETE PROPERTY
      </button>
    </div>
  </div>
  <div class="edit-property-tab" *ngIf="!isLoading">
    <mat-tab-group>
      <mat-tab label="Property Info">
        <div style="display: flex; justify-content: space-between; width: 100%; margin-top: 20px; margin-bottom: 20px">
          <div style="width: 45%;">
            <div *ngIf="property && !property.floorPlan"
              style="font-size: 16px;font-weight: 400;color:rgba(222, 222, 222, 0.6);margin-bottom: 1rem;">
              No floor plan
            </div>
            <div *ngIf="property && property.floorPlan"
              style="font-size: 16px;font-weight: 400;color:rgba(222, 222, 222, 0.6);margin-bottom: 1rem;">
              Current floor plan
            </div>
            <div
              style="width: 100%; border: 1px solid rgba(222, 222, 222, 0.2); padding: 24px; border-radius: 6px; display: flex; justify-content: space-between; align-items: center;box-sizing: border-box;">
              <div *ngIf="property && property.floorPlan" style="color: #DEDEDE">{{property.floorPlan.notes}}</div>
              <button mat-button (click)="openFloorPlanDialog()"
                style="color: #DEDEDE; background: #161616; font-size: 16px;border:1px solid #DEDEDE;width: 280px; ">
                {{property && property.floorPlan ? 'Change floor plan' : 'Add a floor plan'}}
              </button>
            </div>
          </div>
          <div style="width: 45%;">
            <ng-container *ngIf="property && (!property.documents || property.documents.length === 0 )">
              <div style="font-size: 16px;font-weight: 400;color:rgba(222, 222, 222, 0.6);margin-bottom: 1rem;">No
                document</div>
            </ng-container>
            <div
              style="width: 100%; border: 1px solid rgba(222, 222, 222, 0.2); padding: 24px; border-radius: 6px; display: flex; justify-content: space-between; align-items: center;box-sizing: border-box;">
              <ng-container *ngIf="property && property.documents && property.documents.length > 0">
                <div style="font-size: 16px;font-weight: 400;color:rgba(222, 222, 222, 0.6);margin-bottom: 1rem;">
                  {{property.documents.length}} document{{property.documents.length > 1 ? 's are ' : ' is '}}attached
                  to {{property.unitNum}}</div>
              </ng-container>
              <div *ngIf="property && property.documents && property.documents.length == 0"> </div>
              <button mat-button style="color: #DEDEDE; background: #161616; font-size: 16px;border:1px solid #DEDEDE; "
                (click)="openDocumentDialog()">Manage Documents
              </button>
            </div>
          </div>
        </div>
        <form [formGroup]="reactiveForm" style="display: flex; flex-direction: column"
          (keydown.enter)="$event.preventDefault()">
          <div style="display: flex; justify-content: space-between">
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Property type</mat-label>
                <mat-select matInput formControlName="type" required>
                  <mat-option [value]=1>House</mat-option>
                  <mat-option [value]=2>Townhouse</mat-option>
                  <mat-option [value]=3>Apartment</mat-option>
                  <mat-option [value]=4>Land</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Status</mat-label>
                <mat-select matNativeControl formControlName="status" required>
                  <mat-option [value]=6>Sold</mat-option>
                  <mat-option [value]=5>Unconditional</mat-option>
                  <mat-option [value]=4>Exchange conditional</mat-option>
                  <mat-option [value]=3>Reserved</mat-option>
                  <mat-option [value]=2>EOI</mat-option>
                  <mat-option [value]=1>Available</mat-option>
                  <mat-option [value]=0>Unavailable</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>{{this.reactiveForm.get('type').value == 3 ? 'Apartment number' : 'Property number'}}
                </mat-label>
                <input matInput formControlName="pNumber" required>
              </mat-form-field>
            </div>
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style"
                [ngStyle]="{zIndex: reactiveForm.get('type').value == 3 ? '1' : '-1'}">
                <mat-label>Apartment floor level</mat-label>
                <input matInput formControlName="level" required>
                <mat-error *ngIf="reactiveForm.get('level').invalid">Invalid floor level (ony
                  0-999/GC/GB/GA/G/LG/L/B/B1/B2/B3/B4/B5 are allowed)
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <!-- <div style="display: flex; justify-content: space-between">
            <mat-form-field color="accent" appearance="fill" class="label-style"
              *ngIf="reactiveForm.get('status').value == 4 || reactiveForm.get('status').value == 5 || reactiveForm.get('status').value == 6">
              <mat-label>Sold date</mat-label>
              <input matInput [matDatepicker]="picker" (dateChange)="getSoldDate($event)" formControlName="soldDate">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker [startAt]="reactiveForm.get('soldDate').value"
                [disabled]="reactiveForm.get('status').value == 5 || reactiveForm.get('status').value == 6">
              </mat-datepicker>
            </mat-form-field>
            <mat-form-field color="accent" appearance="fill" class="label-style"
              *ngIf="reactiveForm.get('status').value == 6">
              <mat-label>Settled date</mat-label>
              <input matInput [matDatepicker]="picker" (dateChange)="getSettledDate($event)"
                formControlName="settledDate">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker [startAt]="reactiveForm.get('settledDate').value"
                [disabled]="!(reactiveForm.get('status').value == 6)"></mat-datepicker>
            </mat-form-field>
          </div> -->
          <div style="display: flex; justify-content: space-between">
            <div class="label5">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Lot number</mat-label>
                <input matInput formControlName="lotNumber">
              </mat-form-field>
            </div>
            <div class="label5">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Commission</mat-label>
                <input matInput formControlName="commission">
              </mat-form-field>
            </div>
            <div class="label5">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Commission unit</mat-label>
                <mat-select formControlName="commissionUnit">
                  <mat-option value="%">%</mat-option>
                  <mat-option value="AUD">AUD</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="label5">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Total price</mat-label>
                <span matPrefix>AUD&nbsp;</span>
                <input class="right-align" matInput type="number"
                  onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
                  formControlName="totalPrice" required>
                <span matSuffix>.00</span>
              </mat-form-field>
            </div>
            <div class="label5">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Extra cost</mat-label>
                <span matPrefix>AUD&nbsp;</span>
                <input class="right-align" matInput type="number"
                  onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
                  formControlName="extraCost">
                <span matSuffix>.00</span>
              </mat-form-field>
            </div>
          </div>
          <div style="border-bottom: 0.5px solid rgba(222, 222, 222, 0.2);margin-bottom: 48px;"></div>
          <div style="font-size: 24px;color: #DEDEDE;font-weight: 500;line-height:28px;margin-bottom: 24px;">Bedrooms,
            Bathrooms & extra Information</div>
          <div style="display: flex; justify-content: space-between">
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Bedroom</mat-label>
                <input matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                  formControlName="bed" min="0" required>
              </mat-form-field>
            </div>
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Bathrooms</mat-label>
                <input matInput type="text"
                  formControlName="bath" min="0" required
                       (input)="validateInput($event)">
              </mat-form-field>
            </div>
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Car Spaces</mat-label>
                <input matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                  formControlName="car" min="0" required >
              </mat-form-field>
            </div>
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Stud Room</mat-label>
                <input matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                  formControlName="study" min="0" required>
              </mat-form-field>
            </div>
            <!--      <mat-form-field appearance="outline">-->
            <!--        <mat-label>Living room</mat-label>-->
            <!--        <input matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" formControlName="livingRoom">-->
            <!--      </mat-form-field>-->
          </div>
          <div style="display: flex; justify-content: space-between">
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Storeys</mat-label>
                <input matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                  formControlName="storeys" min="0" required>
              </mat-form-field>
            </div>
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Internal size</mat-label>
                <input matInput type="number" onKeypress="return (/[\d|\.]/.test(String.fromCharCode(event.keyCode)))"
                  formControlName="internalArea" min="0" required (change)="valueChange($event)">
                <span matSuffix>m²</span>
              </mat-form-field>
            </div>
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>External size 1</mat-label>
                <input matInput type="number" onKeypress="return (/[\d|\.]/.test(String.fromCharCode(event.keyCode)))"
                  formControlName="externalArea1" min="0" required (change)="valueChange($event)">
                <span matSuffix>m²</span>
              </mat-form-field>
            </div>
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>External size 2</mat-label>
                <input matInput type="number" onKeypress="return (/[\d|\.]/.test(String.fromCharCode(event.keyCode)))"
                  formControlName="externalArea2" min="0" required (change)="valueChange($event)">
                <span matSuffix>m²</span>
              </mat-form-field>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between">
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Total size</mat-label>
                <input matInput type="totalArea" formControlName="totalArea" min="0" required >
                <span matSuffix>m²</span>
              </mat-form-field>
            </div>
            <div class="label4">
              <mat-form-field appearance="outline" *ngIf="this.reactiveForm.get('type').value != 3" class="label-style">
                <mat-label>Land size</mat-label>
                <input matInput type="number" onKeypress="return (/[\d|\.]/.test(String.fromCharCode(event.keyCode)))"
                  min="0" formControlName="landArea">
                <span matSuffix>m²</span>
              </mat-form-field>
            </div>
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Aspect</mat-label>
                <select matNativeControl formControlName="orientation">
                  <option>None</option>
                  <option [value]=1>North</option>
                  <option [value]=2>South</option>
                  <option [value]=3>East</option>
                  <option [value]=4>West</option>
                  <option [value]=5>North-east</option>
                  <option [value]=6>North-west</option>
                  <option [value]=7>South-east</option>
                  <option [value]=8>South-west</option>
                </select>
              </mat-form-field>
            </div>
            <div class="label4">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>View</mat-label>
                <select matNativeControl formControlName="view">
                  <option>None</option>
                  <option [value]=1>Park</option>
                  <option [value]=2>Garden</option>
                  <option [value]=3>Ocean</option>
                  <option [value]=4>Mountain</option>
                </select>
              </mat-form-field>
            </div>
          </div>
          <mat-form-field appearance="outline" class="label-style">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description" style="height: 100px"></textarea>
          </mat-form-field>
          <div style="border-bottom: 0.5px solid rgba(222, 222, 222, 0.2);margin-bottom: 48px;"></div>
          <div style="font-size: 24px;color: #DEDEDE;font-weight: 500;line-height:28px;margin-bottom: 24px;">Stamp Duty,
            council fee & Estimated rates</div>
          <div fxLayout="row" fxLayoutGap="40px">

            <!--      <mat-form-field appearance="outline">-->
            <!--        <mat-label>Land price</mat-label>-->
            <!--        <span matPrefix>AUD&nbsp;</span>-->
            <!--        <input class="right-align" matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" formControlName="landPrice">-->
            <!--        <span matSuffix>.00</span>-->
            <!--      </mat-form-field>-->
            <!--      <mat-form-field appearance="outline">-->
            <!--        <mat-label>House price</mat-label>-->
            <!--        <span matPrefix>AUD&nbsp;&nbsp;&nbsp;</span>-->
            <!--        <input class="right-align" matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" formControlName="housePrice">-->
            <!--        <span matSuffix>.00</span>-->
            <!--      </mat-form-field>-->
          </div>


          <!--    <mat-form-field appearance="outline">-->
          <!--      <mat-label>Commission fee</mat-label>-->
          <!--      <span matPrefix>AUD&nbsp;</span>-->
          <!--      <input class="right-align" matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" formControlName="commissionFee">-->
          <!--      <span matSuffix>.00</span>-->
          <!--    </mat-form-field>-->
          <mat-form-field color="accent" appearance="fill" class="label-style">
            <mat-label>Listing Date</mat-label>
            <input matInput [matDatepicker]="picker" (dateChange)="getListingDate($event)"
              formControlName="listingDate">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker [startAt]="reactiveForm.get('listingDate').value" [disabled]="false">
            </mat-datepicker>
          </mat-form-field>
          <div style="display: flex; justify-content: space-between">
            <div class="label2">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Estimated rates</mat-label>
                <span matPrefix>AUD&nbsp;</span>
                <input class="right-align" matInput type="number"
                  onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
                  formControlName="estimatedRates">
                <span matSuffix>.00</span>
              </mat-form-field>
            </div>
            <div class="label2">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Estimated rental returns</mat-label>
                <span matPrefix>AUD&nbsp;</span>
                <input class="right-align" matInput type="number"
                  onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
                  formControlName="estimatedRentalReturns">
                <span matSuffix>.00</span>
              </mat-form-field>
            </div>
          </div>

          <div style="display: flex; justify-content: space-between">
            <div class="label3">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Estimated owner's corporation fees</mat-label>
                <span matPrefix>AUD&nbsp;</span>
                <input class="right-align" matInput type="number"
                  onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
                  formControlName="estimatedOwnersCorporationFee">
                <span matSuffix>.00</span>
              </mat-form-field>
            </div>
            <div class="label3">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Stamp duty</mat-label>
                <span matPrefix>AUD&nbsp;</span>
                <input class="right-align" matInput type="number"
                  onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
                  formControlName="stampDuty">
                <span matSuffix>.00</span>
              </mat-form-field>
            </div>
            <div class="label3">
              <mat-form-field appearance="outline" class="label-style">
                <mat-label>Council fee</mat-label>
                <span matPrefix>AUD&nbsp;</span>
                <input class="right-align" matInput type="number"
                  onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
                  formControlName="councilFee">
                <span matSuffix>.00</span>
              </mat-form-field>
            </div>
          </div>
          <!--    <div>-->
          <!--      <h4>Terms</h4>-->
          <!--      <input-->
          <!--        #termsInput-->
          <!--        style="display: none"-->
          <!--        type="file"-->
          <!--        multiple=""-->
          <!--        (change)="onFileChangeForTerms($event)">-->
          <!--      <button (click)="termsInput.click()"-->
          <!--              mat-button-->
          <!--              style="border: 1px solid #bababa; margin-bottom: 20px">-->
          <!--        Click here to select files-->
          <!--      </button>-->
          <!--    </div>-->
          <!--    <ng-container *ngIf="selectedTermsAttachments.length > 0">-->
          <!--      <p *ngFor="let file of selectedTermsAttachments" style="display: flex; align-items: center; margin-top: 0px">-->
          <!--        <mat-icon style="color: #b7b7b7; margin-right: 5px">insert_drive_file</mat-icon>-->
          <!--        {{file.name}} ({{(file.size / 1098304).toFixed(2)}} MB)-->
          <!--      </p>-->
          <!--    </ng-container>-->

          <div class="flex justify-end">
            <button mat-button
              style="width: 466px;height: 52px;border: 1px solid #DEDEDE;color: #DEDEDE;border-radius: 8px;background-color: #161616;"
              (click)="updateProperty()">
              Update
            </button>
          </div>


        </form>
      </mat-tab>
      <mat-tab label="Tags">
        <app-property-tags *ngIf="property" [property]="property" [project]="project"></app-property-tags>
      </mat-tab>
      <mat-tab label="Inclusions">
        <app-property-inclusions *ngIf="property" [property]="property" [project]="project"></app-property-inclusions>
      </mat-tab>
      <mat-tab label="Buyer">
        <app-buyer-info *ngIf="property" [property]="property" [project]="project"></app-buyer-info>
      </mat-tab>
      <mat-tab label="Buyer Choice">
        <app-buyer-choice *ngIf="property" [property]="property"></app-buyer-choice>
      </mat-tab>
      <mat-tab label="Channel Agency">
        <app-agency-info></app-agency-info>
      </mat-tab>
      <mat-tab label="Lawyer">
        <app-lawyer-info *ngIf="property" [property]="property"></app-lawyer-info>
      </mat-tab>

    </mat-tab-group>

  </div>
  <app-loading *ngIf="isLoading"></app-loading>

</div>
